// extracted by mini-css-extract-plugin
module.exports = {"call":"call_call__1K0KU","ownerTiles":"call_ownerTiles__3afxj","gamerTiles":"call_gamerTiles__1jfTU"};